import { number } from "../../../config";

/**
 * Sorts team work information controls using admin-defined order string (comma-separated ids).
 * Mirrors WorkInformationSection filtering for fixed admin-only range (10–16).
 */
export const sortWorkInformationsByOrder = (controls, sortingOrderStr) => {
  let sorted = [...(controls || [])].filter(
    (control) => !(control?.fixedVariableId >= number.TEN && control?.fixedVariableId <= number.SIXTEEN)
  );
  if (!sortingOrderStr) return sorted;
  const sortingIds = sortingOrderStr.split(",").map((id) => id.trim());
  return sorted.sort((a, b) => {
    const aIndex = sortingIds.indexOf(a._id);
    const bIndex = sortingIds.indexOf(b._id);
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    return 0;
  });
};
